import { Violation, ViolationSeverity } from '@skylab-shared/core';

export class InventoryGoodsIssueAdjustmentGoodsIssueDateEarlierThanAdjustedError extends Violation {
    public constructor() {
        super(ViolationSeverity.Error, 'business.inventory.goods-issue-adjustment.validation.goods-issue-date.earlier-than-adjusted');
    }
}
